const autoNgTemplateLoaderTemplate1 = require('./views/account/account.html');
const autoNgTemplateLoaderTemplate2 = require('./views/auth/auth.html');
const autoNgTemplateLoaderTemplate3 = require('./views/internal-auth/internal-auth.html');
const autoNgTemplateLoaderTemplate4 = require('./views/logout/logout.html');
const autoNgTemplateLoaderTemplate5 = require('./views/init/admin/initAdmin.html');
const autoNgTemplateLoaderTemplate6 = require('./views/settings/authentication/settingsAuthentication.html');
const autoNgTemplateLoaderTemplate7 = require('./views/tags/tags.html');
const autoNgTemplateLoaderTemplate8 = require('./views/users/edit/user.html');

import { getEnvironments } from '@/react/portainer/environments/environment.service';
import { getSettings } from '@/react/portainer/settings/settings.service';
import { filterParam, paginationParams } from './helpers/stateParamHelper';

import { featureFlagsModule } from './feature-flags';
import './rbac';
import './registry-management';
import licenseManagementModule from './license-management';
import settingsModule from './settings';
import userActivityModule from './user-activity';
import componentsModule from './components';
import servicesModule from './services';
import { reactModule } from './react';
import { sidebarModule } from './react/views/sidebar';
import environmentsModule from './environments';
import { helpersModule } from './helpers';
import { AccessHeaders, requiresAuthHook } from './authorization-guard';

angular
  .module('portainer.app', [
    'portainer.oauth',
    'portainer.rbac',
    'portainer.registrymanagement',
    licenseManagementModule,
    componentsModule,
    settingsModule,
    userActivityModule,
    featureFlagsModule,
    servicesModule,
    reactModule,
    sidebarModule,
    environmentsModule,
    helpersModule,
  ])
  .config([
    '$stateRegistryProvider',
    function ($stateRegistryProvider) {
      'use strict';

      var root = {
        name: 'root',
        abstract: true,
        onEnter: /* @ngInject */ function onEnter($async, StateManager, Authentication, Notifications, $state) {
          return $async(async () => {
            const appState = StateManager.getState();
            if (!appState.loading) {
              return;
            }
            try {
              const loggedIn = await Authentication.init();
              await StateManager.initialize();
              if (!loggedIn && isTransitionRequiresAuthentication($state.transition)) {
                $state.go('portainer.logout');
                return Promise.reject('Unauthenticated');
              }
            } catch (err) {
              Notifications.error('Failure', err, 'Unable to retrieve application settings');
              throw err;
            }
          });
        },
        views: {
          'sidebar@': {
            component: 'sidebar',
          },
        },
        data: {
          access: AccessHeaders.Restricted,
        },
      };

      var endpointRoot = {
        name: 'endpoint',
        url: '/:endpointId',
        parent: 'root',
        abstract: true,
        resolve: {
          endpoint: /* @ngInject */ function endpoint($async, $state, $transition$, EndpointProvider, EndpointService, Notifications) {
            return $async(async () => {
              try {
                const endpointId = +$transition$.params().endpointId;

                const endpoint = await EndpointService.endpoint(endpointId);
                if ((endpoint.Type === 4 || endpoint.Type === 7) && !endpoint.EdgeID) {
                  $state.go('portainer.endpoints.endpoint', { id: endpoint.Id });
                  return;
                }

                EndpointProvider.setCurrentEndpoint(endpoint);

                return endpoint;
              } catch (e) {
                const nextTransition = $state.transition && $state.transition.to();
                const nextTransitionName = nextTransition ? nextTransition.name : '';
                if (nextTransitionName === 'kubernetes.nodeshell') {
                  return;
                }
                Notifications.error('Failed loading environment', e);
                $state.go('portainer.home', {}, { reload: true });
                return;
              }
            });
          },
        },
      };

      var portainer = {
        name: 'portainer',
        parent: 'root',
        abstract: true,
      };

      var account = {
        name: 'portainer.account',
        url: '/account',
        views: {
          'content@': {
            templateUrl: autoNgTemplateLoaderTemplate1,
            controller: 'AccountController',
          },
        },
        data: {
          docs: '/user/account-settings',
        },
      };

      const tokenCreation = {
        name: 'portainer.account.new-access-token',
        url: '/tokens/new',
        views: {
          'content@': {
            component: 'createUserAccessToken',
          },
        },
      };

      const createHelmRepository = {
        name: 'portainer.account.createHelmRepository',
        url: '/helm-repository/new',
        views: {
          'content@': {
            component: 'createHelmRepositoryView',
          },
        },
      };

      var authentication = {
        name: 'portainer.auth',
        url: '/auth',
        params: {
          reload: false,
        },
        views: {
          'content@': {
            templateUrl: autoNgTemplateLoaderTemplate2,
            controller: 'AuthenticationController',
            controllerAs: 'ctrl',
          },
          'sidebar@': {},
        },
        data: {
          access: undefined,
        },
      };
      var internalAuthentication = {
        name: 'portainer.internal-auth',
        url: '/internal-auth',
        params: {
          reload: false,
        },
        views: {
          'content@': {
            templateUrl: autoNgTemplateLoaderTemplate3,
            controller: 'InternalAuthenticationController',
            controllerAs: 'ctrl',
          },
          'sidebar@': {},
        },
        data: {
          access: undefined,
        },
      };

      const logout = {
        name: 'portainer.logout',
        url: '/logout',
        params: {
          error: '',
        },
        views: {
          'content@': {
            templateUrl: autoNgTemplateLoaderTemplate4,
            controller: 'LogoutController',
            controllerAs: 'ctrl',
          },
          'sidebar@': {},
        },
        data: {
          access: undefined,
        },
      };

      var endpoints = {
        name: 'portainer.endpoints',
        url: '/endpoints',
        views: {
          'content@': {
            component: 'environmentsListView',
          },
        },
        data: {
          docs: '/admin/environments/environments',
        },
      };

      var endpoint = {
        name: 'portainer.endpoints.endpoint',
        url: '/:id?redirectTo',
        params: {
          redirectTo: '',
        },
        views: {
          'content@': {
            component: 'environmentsItemView',
          },
        },
      };

      const edgeAutoCreateScript = {
        name: 'portainer.endpoints.edgeAutoCreateScript',
        url: '/aeec',
        views: {
          'content@': {
            component: 'edgeAutoCreateScriptView',
          },
        },
        data: {
          docs: '/admin/environments/aeec',
        },
      };

      var endpointAccess = {
        name: 'portainer.endpoints.endpoint.access',
        url: '/access',
        views: {
          'content@': {
            component: 'environmentAccessView',
          },
        },
      };

      var groups = {
        name: 'portainer.groups',
        url: '/groups',
        views: {
          'content@': {
            component: 'environmentGroupsListView',
          },
        },
        data: {
          docs: '/admin/environments/groups',
          access: AccessHeaders.Admin,
        },
      };

      var group = {
        name: 'portainer.groups.group',
        url: '/:id?tab',
        views: {
          'content@': {
            component: 'environmentGroupEditView',
          },
        },
        params: {
          id: {
            type: 'int',
          },
          tab: {
            dynamic: true,
          },
        },
      };

      var groupCreation = {
        name: 'portainer.groups.new',
        url: '/new',
        views: {
          'content@': {
            component: 'environmentGroupCreateView',
          },
        },
      };

      var home = {
        name: 'portainer.home',
        url: '/home?redirect&environmentId&environmentName&route&groupBy&groupFilter&search&order',
        params: {
          ...paginationParams(),
          sort: filterParam(),
          order: filterParam(),
          groupBy: filterParam(),
          groupFilter: filterParam(),
        },
        views: {
          'content@': {
            component: 'homeView',
          },
        },
        data: {
          docs: '/user/home',
        },
      };

      var gitopsBase = {
        name: 'portainer.gitops',
        url: '/gitops',
        abstract: true,
      };

      var workflows = {
        name: 'portainer.gitops.workflows',
        url: '/workflows?search&sort&order&page&pageSize&status&type&platform&groupBy&groupFilter',
        data: { docs: '/user/app-delivery/workflows' },
        params: {
          ...paginationParams(),
          sort: filterParam(),
          order: filterParam(),
          status: filterParam(),
          type: filterParam(),
          platform: filterParam(),
          groupBy: filterParam(),
          groupFilter: filterParam(),
        },
        views: {
          'content@': {
            component: 'workflowsView',
          },
        },
      };

      var gitopsWorkflowDetail = {
        name: 'portainer.gitops.workflows.item',
        url: '/:workflowId',
        views: {
          'content@': {
            component: 'workflowItemView',
          },
        },
      };

      const gitopsWorkflowCreate = {
        name: 'portainer.gitops.workflows.new',
        url: '/new',
        views: {
          'content@': {
            component: 'workflowCreateView',
          },
        },
        data: {
          access: AccessHeaders.EdgeAdmin,
        },
      };

      const gitopsWorkflowEdit = {
        name: 'portainer.gitops.workflows.edit',
        url: '/:workflowId/edit',
        views: {
          'content@': {
            component: 'workflowEditView',
          },
        },
        data: {
          access: AccessHeaders.EdgeAdmin,
        },
      };

      var gitopsSources = {
        name: 'portainer.gitops.sources',
        url: '/sources?search&sort&order&page&pageSize&status&type',
        data: { docs: '/user/app-delivery/sources' },
        params: {
          ...paginationParams(),
          sort: filterParam(),
          order: filterParam(),
          status: filterParam(),
          type: filterParam(),
        },
        views: {
          'content@': {
            component: 'sourcesListView',
          },
        },
      };

      var gitopsSourceDetail = {
        name: 'portainer.gitops.sources.item',
        url: '/:sourceId?tab',
        params: {
          tab: filterParam('settings'),
        },
        views: {
          'content@': {
            component: 'sourceItemView',
          },
        },
      };

      const gitopsSourceCreate = {
        name: 'portainer.gitops.sources.new',
        url: '/new',
        views: {
          'content@': {
            component: 'sourceCreateView',
          },
        },
      };

      var init = {
        name: 'portainer.init',
        abstract: true,
        url: '/init',
        views: {
          'sidebar@': {},
        },
        data: {
          access: undefined,
        },
      };

      var initAdmin = {
        name: 'portainer.init.admin',
        url: '/admin',
        views: {
          'content@': {
            templateUrl: autoNgTemplateLoaderTemplate5,
            controller: 'InitAdminController',
          },
        },
      };

      const initLicense = {
        name: 'portainer.init.license',
        url: '/license',
        views: {
          'content@': {
            component: 'initLicenseView',
          },
        },
      };
      const initEdge = {
        name: 'portainer.init.edge',
        url: '/edge',
        views: {
          'content@': {
            component: 'initEdgeView',
          },
        },
      };
      var monitoring = {
        name: 'portainer.monitoring',
        url: '/monitoring?environmentName&metrics&orchestrator',
        views: {
          'content@': {
            component: 'monitoringView',
          },
        },
        params: {
          environmentName: null,
          metrics: null,
          orchestrator: null,
        },
      };

      var logging = {
        name: 'portainer.logging',
        url: '/logging',
        views: {
          'content@': {
            component: 'loggingView',
          },
        },
      };

      var alertingBase = {
        name: 'portainer.alerting',
        url: '/alerting',
        abstract: true,
      };

      var alertingDatatables = {
        name: 'portainer.alerting.index',
        url: '?tab',
        views: {
          'content@': {
            component: 'alertsView',
          },
        },
        params: {
          tab: null,
        },
      };

      const alertingRule = {
        name: 'portainer.alerting.rule',
        url: '/rule/:id?tab',
        views: {
          'content@': {
            component: 'alertsRuleView',
          },
        },
        params: {
          id: {
            type: 'int',
          },
          tab: null,
        },
      };

      var settings = {
        name: 'portainer.settings',
        url: '/settings?section',
        views: {
          'content@': {
            component: 'settingsView',
          },
        },
        data: {
          docs: '/admin/settings/general',
          access: AccessHeaders.Admin,
        },
        params: {
          section: null,
        },
      };

      var settingsAuthentication = {
        name: 'portainer.settings.authentication',
        url: '/auth',
        views: {
          'content@': {
            templateUrl: autoNgTemplateLoaderTemplate6,
            controller: 'SettingsAuthenticationController',
          },
        },
        data: {
          docs: '/admin/settings/authentication',
        },
      };

      const settingsCloud = {
        name: 'portainer.settings.sharedcredentials',
        url: '/cloud',
        views: {
          'content@': {
            component: 'settingsSharedCredentialsView',
          },
        },
        data: {
          docs: '/admin/settings/credentials',
        },
      };

      const addCloudCredential = {
        name: 'portainer.settings.sharedcredentials.addCredential',
        url: '/credentials/new',
        views: {
          'content@': {
            component: 'addSharedCredentialsView',
          },
        },
      };

      const editCloudCredential = {
        name: 'portainer.settings.sharedcredentials.credential',
        url: '/credentials/:id',
        views: {
          'content@': {
            component: 'editSharedCredentialsView',
          },
        },
        params: {
          providerType: null,
        },
      };

      var settingsEdgeCompute = {
        name: 'portainer.settings.edgeCompute',
        url: '/edge',
        views: {
          'content@': {
            component: 'settingsEdgeComputeView',
          },
        },
        data: {
          docs: '/admin/settings/edge',
        },
      };

      var tags = {
        name: 'portainer.tags',
        url: '/tags',
        views: {
          'content@': {
            templateUrl: autoNgTemplateLoaderTemplate7,
            controller: 'TagsController',
          },
        },
        data: {
          docs: '/admin/environments/tags',
          access: AccessHeaders.Admin,
        },
      };

      var policies = {
        name: 'portainer.policies',
        url: '/policies',
        views: {
          'content@': {
            component: 'policiesView',
          },
        },
        data: {
          docs: '/admin/environments/policies',
          access: AccessHeaders.Admin,
        },
      };

      var policyCreate = {
        name: 'portainer.policies.create',
        url: '/create?type&step&template',
        views: {
          'content@': {
            component: 'policyCreateView',
          },
        },
        data: {
          docs: '/admin/environments/policies',
          access: AccessHeaders.Admin,
        },
        params: {
          type: { value: null, squash: true },
          step: { value: null, squash: true },
          template: { value: null, squash: true },
        },
      };

      var policy = {
        name: 'portainer.policy',
        url: '/policies/:id?tab',
        views: {
          'content@': {
            component: 'policyDetailView',
          },
        },
        data: {
          docs: '/admin/environments/policies',
          access: AccessHeaders.Admin,
        },
        params: {
          tab: null,
        },
      };

      var users = {
        name: 'portainer.users',
        url: '/users',
        views: {
          'content@': {
            component: 'usersListView',
          },
        },
        data: {
          docs: '/admin/user/users',
          access: AccessHeaders.Restricted, // allow for team leaders
        },
      };

      var user = {
        name: 'portainer.users.user',
        url: '/:id',
        views: {
          'content@': {
            templateUrl: autoNgTemplateLoaderTemplate8,
            controller: 'UserController',
          },
        },
      };

      var recommendations = {
        name: 'portainer.recommendations',
        url: '/recommendations',
        views: {
          'content@': {
            component: 'recommendationsView',
          },
        },
        data: {
          docs: '/admin/recommendations',
          access: AccessHeaders.Admin,
        },
      };

      var addons = {
        name: 'portainer.addons',
        url: '/addon-management',
        views: {
          'content@': {
            component: 'addonsView',
          },
        },
        data: {
          docs: '/admin/add-ons',
          access: AccessHeaders.Admin,
        },
      };

      var addon = {
        // needs to exactly match the 'portainer.addons' prefix, so the addons sidebar item stays active
        name: 'portainer.addons.addon',
        url: '/:id?tab&upgrade',
        views: {
          'content@': {
            component: 'addonDetailView',
          },
        },
        data: {
          docs: '/admin/add-ons/managing-an-installed-add-on',
          access: AccessHeaders.Admin,
        },
        params: {
          tab: null,
          upgrade: null,
        },
      };

      var addonInstall = {
        name: 'portainer.addons.install',
        url: '/:id/install',
        views: {
          'content@': {
            component: 'addonInstallView',
          },
        },
        data: {
          docs: '/admin/add-ons/installing-an-add-on',
          access: AccessHeaders.Admin,
        },
      };

      // Landing page for users whose team has no accessible add-on, and for a
      // request the add-on gateway has no route for (?addon names it). Clears the
      // inherited 'restricted' access so it isn't caught by the same
      // portainerAccessDenied redirect it's the destination of (see authorization-guard.ts).
      var noAddonAccess = {
        name: 'portainer.no-addon-access',
        url: '/no-addon-access?addon',
        views: {
          'content@': {
            component: 'noAddonAccessView',
          },
          'sidebar@': {},
        },
        data: {
          access: undefined,
        },
      };

      $stateRegistryProvider.register(root);
      $stateRegistryProvider.register(endpointRoot);
      $stateRegistryProvider.register(portainer);
      $stateRegistryProvider.register(account);
      $stateRegistryProvider.register(tokenCreation);
      $stateRegistryProvider.register(authentication);
      $stateRegistryProvider.register(internalAuthentication);
      $stateRegistryProvider.register(logout);
      $stateRegistryProvider.register(endpoints);
      $stateRegistryProvider.register(endpoint);
      $stateRegistryProvider.register(endpointAccess);
      $stateRegistryProvider.register(edgeAutoCreateScript);
      $stateRegistryProvider.register(groups);
      $stateRegistryProvider.register(group);
      $stateRegistryProvider.register(groupCreation);
      $stateRegistryProvider.register(home);
      $stateRegistryProvider.register(gitopsBase);
      $stateRegistryProvider.register(workflows);
      $stateRegistryProvider.register(gitopsWorkflowDetail);
      $stateRegistryProvider.register(gitopsWorkflowCreate);
      $stateRegistryProvider.register(gitopsWorkflowEdit);
      $stateRegistryProvider.register(gitopsSources);
      $stateRegistryProvider.register(gitopsSourceDetail);
      $stateRegistryProvider.register(gitopsSourceCreate);
      $stateRegistryProvider.register(init);
      $stateRegistryProvider.register(initAdmin);
      $stateRegistryProvider.register(initLicense);
      $stateRegistryProvider.register(initEdge);
      $stateRegistryProvider.register(monitoring);
      $stateRegistryProvider.register(logging);
      $stateRegistryProvider.register(alertingBase);
      $stateRegistryProvider.register(alertingDatatables);
      $stateRegistryProvider.register(alertingRule);
      $stateRegistryProvider.register(settings);
      $stateRegistryProvider.register(settingsAuthentication);
      $stateRegistryProvider.register(settingsCloud);
      $stateRegistryProvider.register(addCloudCredential);
      $stateRegistryProvider.register(editCloudCredential);
      $stateRegistryProvider.register(settingsEdgeCompute);
      $stateRegistryProvider.register(tags);
      $stateRegistryProvider.register(policies);
      $stateRegistryProvider.register(policyCreate);
      $stateRegistryProvider.register(policy);
      $stateRegistryProvider.register(users);
      $stateRegistryProvider.register(user);
      $stateRegistryProvider.register(recommendations);
      $stateRegistryProvider.register(addons);
      $stateRegistryProvider.register(addon);
      $stateRegistryProvider.register(addonInstall);
      $stateRegistryProvider.register(noAddonAccess);
      $stateRegistryProvider.register(createHelmRepository);
    },
  ])
  .run(run);

const UNAUTHENTICATED_ROUTES = ['portainer.logout', 'portainer.internal-auth', 'portainer.auth', 'portainer.init.admin'];
function isTransitionRequiresAuthentication(transition) {
  if (!transition) {
    return true;
  }
  const nextTransition = transition && transition.to();
  const nextTransitionName = nextTransition ? nextTransition.name : '';
  return !UNAUTHENTICATED_ROUTES.some((route) => nextTransitionName.startsWith(route));
}

/* @ngInject */
function run($transitions, UserService, Authentication, LicenseService, Notifications) {
  requiresAuthHook($transitions, Authentication);

  $transitions.onBefore({ to: 'portainer.init.*' }, async function (transition) {
    const to = transition.to();
    const stateService = transition.router.stateService;

    try {
      const adminExists = await UserService.administratorExists();
      if (!adminExists) {
        return to.name !== 'portainer.init.admin' ? stateService.target('portainer.init.admin') : true;
      }
    } catch (err) {
      Notifications.error('Failure', err, 'Unable to retrieve admin');
      throw err;
    }

    if (!Authentication.isAuthenticated()) {
      return stateService.target('portainer.auth');
    }

    try {
      const licenseInfo = await LicenseService.info();
      if (!licenseInfo.valid) {
        return to.name !== 'portainer.init.license' ? stateService.target('portainer.init.license') : true;
      }
    } catch (err) {
      Notifications.error('Failure', err, 'Unable to retrieve license info');
      throw err;
    }

    try {
      const endpoints = await getEnvironments({ start: 0, limit: 1, query: { excludeSnapshots: true } });
      if (endpoints.value.length === 0) {
        // On a fresh install (no environments yet), offer the edge compute setup step
        // before the environment wizard — unless edge compute was already configured
        // headlessly via the startup CLI flags, in which case skip straight to the wizard.
        // The step forwards to the wizard on submit/skip; transitions to the wizard don't
        // match this hook, so there's no bounce-back.
        const settings = await getSettings();
        if (settings.EnableEdgeComputeFeatures) {
          return stateService.target('portainer.wizard');
        }

        return to.name !== 'portainer.init.edge' ? stateService.target('portainer.init.edge') : true;
      }

      return stateService.target('portainer.home');
    } catch (err) {
      Notifications.error('Failure', err, 'Unable to retrieve environment info');
      throw err;
    }
  });

  $transitions.onBefore({ to: (state) => !state.name.startsWith('portainer.init') && !UNAUTHENTICATED_ROUTES.includes(state.name) }, function (transition) {
    const stateService = transition.router.stateService;

    async function licenseCheckAsync() {
      try {
        const licenseInfo = await LicenseService.info();
        if (!licenseInfo.valid) {
          return stateService.target('portainer.init.license');
        }
      } catch (err) {
        Notifications.error('Failure', err, 'Unable to retrieve license info');
        throw err;
      }
    }

    licenseCheckAsync();
  });
}
